module.exports = {
  "name": "ru_RU",
  "day": {
    "abbrev": ["Вс.", "Пн.", "Вт.", "Ср.", "Чт.", "Пт.", "Сб."],
    "full": ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"]
  },
  "month": {
    "abbrev": ["янв.", "февр.", "марта", "апр.", "мая", "июня", "июля", "авг.", "сент.", "окт.", "нояб.", "дек."],
    "full": ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]
  },
  "meridiem": ["", ""],
  "date": "%d.%m.%Y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
};